import {
	Directive,
	ElementRef,
	EventEmitter,
	Injector,
	Input,
	Output
} from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { MediaSchema } from 'go-modules/models/media';
import { VideoSceneController } from 'go-modules/video-scene/video-scene.controller';

@Directive({
	selector: 'universal-media-chooser',
	standalone: true
})
export class UniversalMediaChooserDirective extends UpgradeComponent {
	@Input() public options;
	@Input() public ngDisabled: boolean;
	@Input() public umcInstanceName: string;
	@Output() public onEngineInit: EventEmitter<{ engine: VideoSceneController }> =
		new EventEmitter<{ engine: VideoSceneController }>();

	@Output() public onMediaDetermined: EventEmitter<{ media: MediaSchema }> =
		new EventEmitter<{ media: MediaSchema }>();

	constructor (
		elementRef: ElementRef,
		injector: Injector
	) {
		super('universalMediaChooser', elementRef, injector);
	}
}
